import PageShell from "@/components/PageShell";

const CODE = `curl -X POST https://api.coinbuy.org/api/payments \\
  -H "Authorization: Bearer sk_live_..." \\
  -H "Content-Type: application/json" \\
  -d '{
    "amount_try": 1000.00,
    "customer_email": "musteri@ornek.com",
    "order_id": "SIP-1042",
    "description": "Premium Abonelik"
  }'`;

const RESP = `{
  "payment_id": "pay_8f3ka92mx",
  "pay_url": "/pay/pay_8f3ka92mx",
  "expires_at": "2026-06-12T14:30:00Z"
}`;

export default function Developers() {
  return (
    <PageShell title="Geliştiriciler" subtitle="Coinbuy REST API ile kripto ödemeleri uygulamanıza dakikalar içinde entegre edin.">
      <div className="space-y-8">
        <div>
          <h3 className="text-lg font-bold">Kimlik Doğrulama</h3>
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
            Her istekte <code className="rounded bg-muted px-1.5 py-0.5 text-xs">Authorization: Bearer &lt;Secret Key&gt;</code> başlığını gönderin. Secret Key'inizi asla istemci tarafında (frontend) paylaşmayın.
          </p>
        </div>
        <div>
          <h3 className="text-lg font-bold mb-3">Ödeme oluşturma</h3>
          <pre className="overflow-x-auto rounded-xl border border-border bg-[#0d1117] p-5 text-xs leading-relaxed text-slate-200"><code>{CODE}</code></pre>
        </div>
        <div>
          <h3 className="text-lg font-bold mb-3">Yanıt</h3>
          <pre className="overflow-x-auto rounded-xl border border-border bg-[#0d1117] p-5 text-xs leading-relaxed text-emerald-300"><code>{RESP}</code></pre>
        </div>
        <div>
          <h3 className="text-lg font-bold">Webhook Olayları</h3>
          <ul className="mt-3 grid sm:grid-cols-2 gap-2 text-sm text-muted-foreground">
            {["payment.created","payment.pending","payment.detected","payment.confirmed","payment.expired","payment.failed","payout.created","payout.completed","payout.failed"].map((e) => (
              <li key={e} className="rounded-lg border border-border bg-card px-3 py-2 font-mono text-xs">{e}</li>
            ))}
          </ul>
        </div>
      </div>
    </PageShell>
  );
}
